import { RootState } from 'store';

export const selectUsers = (state: RootState) => state.users;
export const selectBlastPage = (state: RootState) => state.blastPage;
export const selectArchived = (state: RootState) => state.archived;
export const selectAgencies = (state: RootState) => state.agencies;
export const selectToken = (state: RootState) => state.token;
